import axios from "axios";

//Connection
import connectConfig from "@/config/connectConfig";

var storage = window.localStorage;
const userObjectStorgae = storage.getItem("userObject");
let token = null;
let userObject = {};

if (userObjectStorgae) {
  userObject = JSON.parse(userObjectStorgae);

  token = userObject.token;
}
class OfficeApi {
  constructor() {
    this.axios = axios.create();
  }
  setUrl(baseURL) {
    this.axios.defaults.baseURL = baseURL;
  }
  setToken(token) {
    this.axios.defaults.headers.Authorization = `${token}`;
  }
}

const officeApi = new OfficeApi();
!(token in ["", undefined]) && officeApi.setToken(token);
connectConfig.backendURLOffice &&
  officeApi.setUrl(connectConfig.backendURLOffice);

export default officeApi;
